// slider js

if(window.innerWidth > 767){
    document.querySelectorAll('.slider--desktop').forEach((slider) => {
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  slider.style.cursor = 'grab';

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX;
    scrollLeft = slider.scrollLeft;
    slider.style.cursor = 'grabbing';
    slider.classList.add('dragging');
  });

  document.addEventListener('mouseup', () => {
    isDown = false;
    slider.style.cursor = 'grab';
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    e.preventDefault();

    const walk = (e.pageX - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });

  slider.addEventListener('dragstart', (e) => {
    e.preventDefault();
  });
});
}


// sizechart js

document.addEventListener('click', function(e){

  if(e.target.closest('.size-chart-btn')){
    document.querySelector('.size-chart-popup')?.classList.add('active');
    document.body.classList.add('sizechart-active')
  }

  if(
    e.target.closest('.size-chart-close') ||
    e.target.classList.contains('size-chart-popup')
  ){
    document.querySelector('.size-chart-popup')?.classList.remove('active');
       document.body.classList.remove('sizechart-active')
  }

});

// snapp scroll
if(document.body.classList.contains('template_index') && window.innerWidth > 1024){
console.log('script one')
setTimeout(function(){
gsap.registerPlugin(ScrollToPlugin);

console.log('script two')
    const sections = gsap.utils.toArray("#MainContent > .shopify-section");

    let lastScroll = window.pageYOffset;
    let autoScrolling = false;
    let timer;

    // ============================
    // CHANGE THIS VALUE
    // 0.30 = 30%
    // 0.40 = 40%
    // 0.50 = 50%
    // This decides how much of the next/previous section
    // should be visible before it snaps.
    // ============================
    const SNAP_POINT = 0.30;

    window.addEventListener("scroll", () => {
console.log('script three')
        if (autoScrolling) return;

        clearTimeout(timer);

        const currentScroll = window.pageYOffset;
        const direction = currentScroll > lastScroll ? "down" : "up";
        lastScroll = currentScroll;

        timer = setTimeout(() => {

            let target = null;

            if (direction === "down") {

                for (let section of sections) {

                    const rect = section.getBoundingClientRect();

                    if (rect.top > 0) {

                        const visible = window.innerHeight - rect.top;
                        const percent = visible / rect.height;

                        if (percent >= SNAP_POINT) {
                            target = section;
                        }

                        break;
                    }
                }

            }
            // Scrolling up: no snap logic, target stays null,
            // function returns below and normal scroll behavior continues.

            if (!target) return;

            autoScrolling = true;

          const header = document.querySelector(".header-wrapper");
const headerHeight = header.getBoundingClientRect().height;

const y =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    headerHeight -
    10;

gsap.to(window, {
    duration: 0.8,
    ease: "power2.out",
    scrollTo: y,
    onComplete() {
        autoScrolling = false;
    }
});

        }, 180);

    }, { passive: true });


},500)
}